import { render, staticRenderFns } from "./GeneralInstitutionWorkLoadAvg.vue?vue&type=template&id=67fbd1b4"
import script from "./GeneralInstitutionWorkLoadAvg.vue?vue&type=script&lang=js"
export * from "./GeneralInstitutionWorkLoadAvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fbd1b4')) {
      api.createRecord('67fbd1b4', component.options)
    } else {
      api.reload('67fbd1b4', component.options)
    }
    module.hot.accept("./GeneralInstitutionWorkLoadAvg.vue?vue&type=template&id=67fbd1b4", function () {
      api.rerender('67fbd1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/GeneralInstitutionWorkLoadAvg.vue"
export default component.exports